import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_EmployeeInformation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_EmployeeInformation' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><center><h3>Employee Information</h3></center></p>
                <p className='w-750'><h4>Personal Information</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Full Name:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_1' name='txtFullName_1' placeholder='Last' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_2' name='txtFullName_2' placeholder='First' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_3' name='txtFullName_3' placeholder='M.I' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_1' name='txtAddress_1' placeholder='Street Address' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_2' name='txtAddress_2' placeholder='Apartment/Unit' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip Code</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtState_2' name='txtState_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtZipCode_3' name='txtZipCode_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Home Phone:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Alternate Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomePhone_1' name='txtHomePhone_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAlternatePhone_2' name='txtAlternatePhone_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>E-Mail Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Social Security Number Or Government I.D:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSocialSecurityNumber' name='txtSocialSecurityNumber' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Birth Date</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Martital Status:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtBirthDate' name='txtBirthDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtMartitalStatus' name='txtMartitalStatus' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Spouse's Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSpouseName' name='txtSpouseName' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Spouse's Employer:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Spouse's Work Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtSpouseName' name='txtSpouseName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSpouseWorkPhone' name='txtSpouseWorkPhone' className='add-only' />
                        </td>
                    </tr>

                </table>
                <p className='w-750'><h4>Job Information</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Title:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Employee I.D:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTitle' name='txtTitle' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtEmployee' name='txtEmployee' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Manager:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Department:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtManager' name='txtManager' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDepartment' name='txtDepartment' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Work Location:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>E-Mail Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWorkLocation' name='txtWorkLocation' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Work Phone:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Cell Phone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWorkPhone' name='txtWorkPhone' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtCellPhone' name='txtCellPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Start Date:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Salary</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSalary' name='txtSalary' className='add-only' />
                        </td>
                    </tr>
                </table>
                
                <p className='w-750'><h4>Emergency Contact Information</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Full Name:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_4' name='txtFullName_4' placeholder='Last' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_5' name='txtFullName_5' placeholder='First' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFullName_6' name='txtFullName_6' placeholder='M.I' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_4' name='txtAddress_4' placeholder='Street Address' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_5' name='txtAddress_5' placeholder='Apartment/Unit' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip Code</span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_4' name='txtCity_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtState_5' name='txtState_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtZipCode_6' name='txtZipCode_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Home Phone:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Alternate Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtHomePhone_3' name='txtHomePhone_3' className='add-only'/>
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtAlternatePhone_4' name='txtAlternatePhone_4' className='add-only'/>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Relationship:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only'/>
                        </td>
                    </tr>
                    </table>







            </div>
        </form>

    )
}   